import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-book-image-icon lucide-book-image",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 8,
			r: 2
		})
	]
});
export default SvgBookImage;
